export enum StereoMode {
    None,
    LeftRight,
    TopBottom
}